import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';

import AuthService from "services/API/Auth/AuthService";
import EPService from 'services/API/expo_partecipazioni/ExpoPartecipazioniService';

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import DashboardLayout from "layouts/DashboardLayout";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
// @mui material components
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import ExpoRichiesteVis from "pages/riservata/expo_richieste/ExpoRichiesteVis";

//validazione lato client
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

//script
import currencyToDouble from "common/script/currencyToDouble";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import MDInput from "common/components/MD/MDInput";
import UtilityService from "services/API/utility/UtilityService";
import ReactHookFormCheckBox from "common/components/mycomponents/ReactHookFormCheckBox";
import MDTypography from "common/components/MD/MDTypography";
import { useFarFieraUIController } from "common/context/FarFieraContext";
import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import SpazioComponent from "../expo_partecipazioni/SpazioComponent";


const ExpoModuliVal = () => {

    const location = useLocation();
    const navigate = useNavigate();


    const [ffcontroller] = useFarFieraUIController();
    const { manifestazione } = ffcontroller;


    const { modo, id_soggetto, chiamante } = location.state;




    // user state for form
    const [richiesta, setRichiesta] = useState({
        idRichiesta: 0,
        ragione_sociale: '',
      
        moduli_obbligatori: [{
            id_modulo: 0,
            nome_modulo: '',

        }]
    });

    const [lista_moduli, setLista_moduli] = useState([{ id_modulo: 0, protocollato: false }]);



    /*---------------------------------------CARICAMENTO DELLE COSE CHE SERVONO-------------------------------------*/



    /* ----------------------------CARICAMENTO E RIEMPIMENTO CAMPI------------------------------------------------- */

    useEffect(() => {
        if (id_soggetto != null && id_soggetto != 0) {
            console.log("soggetto non nullo: id=" + id_soggetto);
            seleziona_soggetto();
        } else {
            console.log("soggetto nullo");
        }
    }, []);



    function seleziona_soggetto() {
        console.log("Carico e seleziono i dettagli :" + id_soggetto);
        if (id_soggetto !== 0) {
            EPService.selezionaRichiesta(id_soggetto)
                .then(response => {
                    console.log(response.data);
                    retrive(response.data);


                })
                .catch(e => {
                    console.log(e);

                });
        }

    }


    function retrive(data) {
        setRichiesta({
            idRichiesta: data.idRichiesta,
            id_utente: data.id_utente,
            manifestazione: data.manifestazione,
            ragione_sociale: data.ragione_sociale,
            rappresentante_legale: data.rappresentante_legale,
            indirizzo:data.indirizzo,
            civico:data.civico,
            indirizzo2:data.indirizzo2,
            cap:data.cap,
            localita:data.localita,
            provincia:data.provincia,
            cf:data.cf,
            piva:data.piva,
            telefono:data.telefono,
            fax:data.fax,
            www:data.www,
            email:data.email,pec:data.pec,
            codice_sdi:data.codice_sdi,
            responsabile_fiera:data.responsabile_fiera,
            responsabile_fiera_telefono:data.responsabile_fiera_telefono,
            responsabile_fiera_cell:data.responsabile_fiera_cell,
            responsabile_fiera_email:data.responsabile_fiera_email,
            isEstero:data.isEstero,
            iban:data.iban,
            iban2:data.iban2,
            swift:data.swift,
            cm_01:data.cm_01,cm_01_descrizione:data.cm_01_descrizione,
              cm_02:data.cm_02,cm_02_descrizione:data.cm_02_descrizione,
                cm_03:data.cm_03,cm_03_descrizione:data.cm_03_descrizione,
              cm_04:data.cm_04,cm_04_descrizione:data.cm_04_descrizione,
              prodotti_servizi:data.prodotti_servizi,
              note:data.note,
              esigenze_espositive:data.esigenze_espositive,
            moduli_obbligatori: data.moduli_obbligatori,

        });
        setLista_moduli([]);
    }


    /* ----------------------------VALIDAZIONE E SALVATAGGIO----------------------------------------------------------------------- */


    const validationSchema = Yup.object().shape({

    });



    const {
        register, //register inputs
        getValues, setValue, control,
        handleSubmit,//handle form submit
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });



    useEffect(() => {

        console.log("Cambiata partecipazione->riempo i campi  " + richiesta.idRichiesta);

      
        richiesta.moduli_obbligatori.map(mod => {
            let name_var = 'protocollato_' + mod.id_modulo;
            let check_protocollato = (
                <ReactHookFormCheckBox label={<MDBox><MDTypography variant="button" fontWeight="regular" color="text" sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
                    &nbsp;&nbsp;Protocollato&nbsp;</MDTypography></MDBox>} name={name_var} control={control}
                    disabled={mod.id_modulo == null || mod.id_modulo === 0} />
            );

            setValue(name_var, mod.protocollato);

            lista_moduli.push({
                id_modulo: mod.id_modulo,
                id_modello: mod.id_modello,
                key: mod.id_modulo,
                nome_modello: mod.nome_modello,
                nome_file: mod.nome_file,
                id_partecipazione: mod.id_partecipazione,
                protocollato: mod.protocollato,
                check_protocollato: check_protocollato,
            })

        }


        );


    }, [richiesta]);

    /*------------------------FUNZIONALITA PAGINA------------------------------------------- */


    async function vedi_modulo(idModulo, nome_file) {
        if (AuthService.isTokenOk()) {
            ExpoPartecipazioniService.download_pdf_modulo(idModulo)
                .then(response => {

                    return response.data;
                })
                .then(blob => {

                    var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                    var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                    var url = URL.createObjectURL(blobb);
                    var a = document.createElement('a');
                    a.href = url;
                    a.target = "_blank";

                    a.download = nome_file;
                    document.body.appendChild(a); // append the element to the dom
                    a.click();
                    a.remove(); // afterwards, remove the element  
                })
                .catch(error => {
                    console.error(error);
                });


        }

    }


    /*
    
        part.moduli_obbligatori.map((modulo) => {
    
            lista_moduli.push({
                id_modulo: modulo.id_modulo,
                key: modulo.id_modulo,
                nome_file: modulo.nome_file,
                id_partecipazione: part.idPartecipazione,
                id_modello: modulo.id_modello,
                nome_modello: modulo.nome_modello,
                protocollato: modulo.protocollato,
    
            })
    
        });*/





    /* ----------------------------SALVATAGGIO E REGISTRAZIONE------------------------------------------------- */




    const [submitted, setSubmitted] = useState(false);


    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);



    const salva_pp = (formData) => {
        if (AuthService.isTokenOk()) {

            console.log(formData);
            setError(null);

            //costruisco dotazioni
            let moduli = [];
            lista_moduli.map(mod => {

                if (mod.id_modulo != null && mod.id_modulo !== 0) {
                    const nome_var = 'protocollato_' + mod.id_modulo;
                    console.log(" ::::::::" + mod.id_modulo + " protocollato=" + formData[nome_var]);
                    var modulo = {
                        id_modulo: mod.id_modulo,
                        id_modello: mod.id_modello,
                        nome_modello: mod.nome_modello,
                        nome_file: mod.nome_file,
                        id_richiesta: mod.id_richiesta,
                        protocollato: formData[nome_var],
                    };
                    moduli.push(modulo);
                }
            });

            var data={
                
                moduli_obbligatori:moduli,

            }



            EPService.valida_moduli(data)
                .then(response => {
                    handleResponse(response, 'OK');
                })
                .catch(errore => {
                    handleError(errore);
                });



        }

    }

    function handleResponse(response, op) {
        //   console.log(response.data);
        setSubmitted(true);

        navigate("/expo_moduli_list", { state: { submitted: true, salvato: op, indietro: true } });
    }


    function handleError(error) {
        setError(error);
        console.log("ERRORE" + error);
        console.log(error.code);

        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log("ERROR:RESPONSE" + error.response.data);
            setErrorMessage(error.response.data);

        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log("EEROR:REQUEST" + error.request);
            setErrorMessage(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            setErrorMessage(error.message);
        }

    }




    /* ------------------------------navigazione -----------------------------------------------------------------*/


    const annulla = () => {
        navigate("/" + chiamante, { state: { indietro: true } });
    }

    const handleKeyDown = (e) => {
        const { key, target } = e

        if (key !== "Enter" || target instanceof HTMLTextAreaElement) {
            return
        }

        e.preventDefault()
    }


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>

                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card >
                            <HeaderForm titolo={"Dati Partecipazione " + richiesta.manifestazione} modo='edit'
                                save={handleSubmit(salva_pp)}
                                exit={annulla} />
                            <MDBox pt={1} pb={3} px={3} component="form" role="form" onKeyDown={handleKeyDown}>
                                <CardContent>
                                    <MDBox>
                                        <MDBox opacity={1} textAlign="center">

                                        </MDBox>
                                        <MDBox pt={4} pb={3} px={3} >
                                            <MDBox mt={5}>
                                                <ExpoRichiesteVis prop={richiesta}></ExpoRichiesteVis>
                                              
                                                        <MDBox>
                                                            <SpazioComponent
                                                                key={richiesta.idRichiesta}
                                                                id={richiesta.idRichiesta}
                                                                richiesta={richiesta}
                                                            />
                                                            </MDBox>


                                                <MDBox>

                                                    {/*moduli obbligatori*/}

                                                    <Card sx={{ height: "100%", boxShadow: true && "none" }}>
                                                        <MDBox pt={2} px={2}>
                                                            <MDTypography color='success' sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
                                                                &nbsp;&nbsp;Moduli Obbligatori:&nbsp;
                                                            </MDTypography>
                                                        </MDBox>
                                                        <MDBox p={2}>
                                                            <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>

                                                                {lista_moduli.map((modulo) => (

                                                                    <MDBox sx={{ display: 'grid', gap: 5, gridTemplateColumns: '4fr 3fr 2fr' }}>
                                                                        <MDTypography variant="button" fontWeight="medium">
                                                                            {modulo.nome_modello}
                                                                        </MDTypography>
                                                                        {(modulo.id_modulo != null && modulo.id_modulo != 0) &&
                                                                            <MDTypography
                                                                                variant="button"
                                                                                fontWeight="regular"
                                                                                color="text"
                                                                                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                                                                onClick={() => vedi_modulo(modulo.id_modulo, modulo.nome_file)}
                                                                            >
                                                                                {modulo.nome_file}
                                                                            </MDTypography>}
                                                                        {(modulo.id_modulo == null || modulo.id_modulo === 0) &&
                                                                            <MDTypography
                                                                                variant="button"
                                                                                fontWeight="regular"
                                                                                color="text"
                                                                                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                                                            >--------------------------  </MDTypography>}
                                                                        <MDBox ml="auto">
                                                                            {modulo.check_protocollato}
                                                                        </MDBox>

                                                                    </MDBox>


                                                                ))}

                                                            </MDBox>
                                                        </MDBox>
                                                    </Card>




                                                </MDBox>

                                                <MDBox sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} mt={4} mb={1}>
                                                    <MDButton variant="outlined" color="success" onClick={annulla} >
                                                        annulla
                                                    </MDButton>
                                                    <MDBox sx={{ flex: '1 1 auto' }} />
                                                    <MDBox ml={2}>

                                                    </MDBox>
                                                    <MDBox ml={2}>
                                                        <MDButton variant="gradient" color="success" onClick={handleSubmit(salva_pp)} type="submit"  >
                                                            Salva
                                                        </MDButton>
                                                    </MDBox>

                                                </MDBox>

                                            </MDBox>

                                        </MDBox>



                                    </MDBox>


                                </CardContent>
                            </MDBox>
                        </Card>
                    </Grid></Grid></MDBox>
            <Footer />
        </DashboardLayout>
    )
}


export default ExpoModuliVal;